/**
 * Modo ativo de quem é aluno E advogado (flag `EnableAcademySwitch`):
 * `academy` abre o app do aluno (menu, dash e rotas do JusRecruta);
 * `advogado` abre a Jusfy comum. Quem é só aluno não tem modo: é sempre
 * `academy`, e a escolha salva aqui é ignorada (ver useIsAcademyUser).
 *
 * Fica no localStorage, por usuário, como o hint do useIsAcademyUser. Primeira
 * versão: vale por navegador; a preferência no servidor fica para depois.
 */
export type AcademyMode = 'academy' | 'advogado';

export const DEFAULT_ACADEMY_MODE: AcademyMode = 'academy';

const MODE_KEY_PREFIX = 'jusfy:academyMode:';

const keyFor = (userId: number | string): string =>
  `${MODE_KEY_PREFIX}${userId}`;

export const readAcademyMode = (
  userId: number | string | null | undefined,
): AcademyMode => {
  if (userId === undefined || userId === null) return DEFAULT_ACADEMY_MODE;
  try {
    return window.localStorage.getItem(keyFor(userId)) === 'advogado'
      ? 'advogado'
      : DEFAULT_ACADEMY_MODE;
  } catch {
    return DEFAULT_ACADEMY_MODE;
  }
};

export const writeAcademyMode = (
  userId: number | string | null | undefined,
  mode: AcademyMode,
): void => {
  if (userId === undefined || userId === null) return;
  try {
    if (mode === DEFAULT_ACADEMY_MODE) {
      window.localStorage.removeItem(keyFor(userId));
    } else {
      window.localStorage.setItem(keyFor(userId), mode);
    }
  } catch {
    /* modo privado / storage cheio: seguimos sem salvar. */
  }
};
